import React, {useMemo} from 'react';
import {BaseEdge, getBezierPath} from '@xyflow/react';
import {objects} from "@atttomyx/shared-utils";
import {colors} from "@atttomyx/shared-constants";

const SelectableEdge = (props) => {
    const {
        id, sourceX, sourceY, targetX, targetY, sourcePosition, targetPosition, selected, style,
        label, labelStyle, labelShowBg, labelBgStyle, labelBgPadding, labelBgBorderRadius, interactionWidth,
        markerStart, markerEnd
    } = props;

    const [edgePath, labelX, labelY] = getBezierPath({
        sourceX: sourceX,
        sourceY: sourceY,
        sourcePosition: sourcePosition,
        targetX: targetX,
        targetY: targetY,
        targetPosition: targetPosition,
    });

    const styleToUse = useMemo(() => {
        let ret = style;

        if (selected) {
            const modified = objects.deepCopy(style);

            modified.stroke = colors.MILESOFT_ORANGE;
            modified.opacity = 1;
            modified.animation = "dashdraw 1s linear infinite";

            ret = modified;
        }

        return ret;
    }, [selected, style]);

    return (
        <BaseEdge
            id={id}
            path={edgePath}
            style={styleToUse}
            labelX={labelX}
            labelY={labelY}
            label={label}
            labelStyle={labelStyle}
            labelShowBg={labelShowBg}
            labelBgStyle={labelBgStyle}
            labelBgPadding={labelBgPadding}
            labelBgBorderRadius={labelBgBorderRadius}
            interactionWidth={interactionWidth}
            markerStart={!selected ? markerStart : undefined}
            markerEnd={!selected ? markerEnd : undefined}
        />
    )
};

export default SelectableEdge;
